<section class="-mt-5 grid grid-cols-2 gap-x-6 border-b border-border lg:grid-cols-4 lg:gap-x-10" aria-label="Kennzahlen der Auswahl">
  @for (kpi of kpis(); track kpi.label; let first = $first) {
    <div class="flex min-w-0 flex-col gap-1 py-6" [class]="first ? '' : 'lg:-ml-10 lg:border-l lg:border-border lg:pl-10'">
      <p class="ks-eyebrow">{{ kpi.label }}</p>
      <p class="mt-1.5 flex flex-wrap items-baseline gap-1.5">
        <span class="text-3xl font-bold leading-9 tracking-tight tabular-nums">{{ kpi.value }}</span>
        <span class="text-dense text-muted-foreground">{{ kpi.unit }}</span>
      </p>
    </div>
  }
</section>

<div class="grid grid-cols-1 items-start gap-x-6 gap-y-3 lg:grid-cols-[12.5rem_minmax(0,1fr)]">
  <app-filter-rail class="-ml-2 block lg:sticky lg:top-44" label="Welche Planungen" [groups]="groups()" [active]="[filter()]" (picked)="pick($any($event))" />

  <div class="min-w-0">
    @if (store.itemsError()) {
      <app-state-panel state="error" title="Die Planungen konnten nicht geladen werden" description="Der Server hat nicht geantwortet. Es ist nichts verloren gegangen."><button hlmBtn type="button" variant="outline" (click)="store.loadItems()">Erneut laden</button></app-state-panel>
    } @else {
    <app-data-table
      [data]="rows()"
      [columns]="columns()"
      [rowId]="getRowId"
      [rowClass]="rowClass"
      [isLoading]="store.itemsLoading()"
      [pageSize]="pageSize"
      [showAddButton]="false"
      searchPlaceholder="Adresse suchen"
      emptyStateTitle="Keine Planungen für diese Auswahl"
      emptyStateDescription="Sobald eine Berechnung Planungen liefert, erscheinen sie hier."
      (rowClick)="select($event.id)"
    />
    }
  </div>
</div>

@if (selected(); as item) {
  <app-side-panel [heading]="heading().street" [subtitle]="heading().place" (closed)="close()">
    <div panelTags class="mt-2 flex flex-wrap items-center gap-1.5">
      <app-stage-chip [stage]="item.stage" />
      @for (mark of marks(); track mark) { <span class="inline-flex h-6 items-center rounded-md border border-border px-2 font-mono text-2xs text-muted-foreground">{{ mark }}</span> }
    </div>
    <span panelActions class="flex gap-1">
      <button hlmBtn type="button" variant="ghost" size="icon" class="!size-8 rounded-md" aria-label="Vorherige" title="K" (click)="step(-1)"><ng-icon name="lucideChevronUp" class="size-4" /></button>
      <button hlmBtn type="button" variant="ghost" size="icon" class="!size-8 rounded-md" aria-label="Nächste" title="J" (click)="step(1)"><ng-icon name="lucideChevronDown" class="size-4" /></button>
    </span>

    @if (detailError()) {
      <div class="p-5"><app-inline-notice tone="error" [message]="detailError()" /></div>
    } @else {
      <div class="relative h-64 shrink-0 bg-foreground">
        @if (analysis(); as current) {
          <app-analysis-viewer class="block h-full" [initialView]="planningView" [analysis]="current" [planningId]="planning()?.id ?? null" [filesOverview]="files()" [visibleViews]="['2d', 'map', '3d']" />
        }
      </div>
      <div class="flex shrink-0 flex-col gap-2 border-b border-border px-5 py-3">
        <div class="flex items-center justify-between gap-2">
          <span class="ks-eyebrow">Planung</span>
          <span class="inline-flex h-6 items-center rounded-md px-2 font-mono text-2xs" [class]="outcomes[item.planning.outcome].classes">{{ outcomes[item.planning.outcome].label }}</span>
        </div>
        @if (item.planning.message) { <p class="text-xs text-muted-foreground">{{ item.planning.message }}</p> }
      </div>
      @if (detailKpis().length) {
        <div class="grid shrink-0 grid-cols-3 border-b border-border">
          @for (kpi of detailKpis(); track kpi.key; let index = $index) {
            <div class="flex min-w-0 flex-col gap-0.5 px-5 py-3" [class.border-l]="index % 3 !== 0" [class.border-t]="index >= 3">
              <span class="ks-eyebrow">{{ kpi.key }}</span>
              <span class="truncate text-sm font-bold">{{ kpi.value }}</span>
            </div>
          }
        </div>
      } @else if (detailLoading()) {
        <div class="h-32 shrink-0 animate-pulse border-b border-border bg-muted/50"></div>
      }
      @if (months().length) {
        <div class="flex shrink-0 flex-col gap-2 border-b border-border px-5 py-3">
          <div class="flex items-baseline justify-between gap-2"><span class="ks-eyebrow">Ertrag je Monat</span><span class="text-xs text-muted-foreground">{{ yearly() }}</span></div>
          <div>
            <div class="grid h-14 grid-cols-12 items-end gap-0.5 border-b border-border">
              @for (month of months(); track $index) {
                <span class="w-full rounded-t-[2px] bg-chart-1" style="min-height: 2px" [style.height.%]="month.height" [title]="month.title"></span>
              }
            </div>
            <div class="mt-1 grid grid-cols-12 gap-0.5 text-center font-mono text-2xs text-muted-foreground/80">
              @for (month of months(); track $index) { <span>{{ month.x }}</span> }
            </div>
          </div>
        </div>
      }
      @if (facts().length) {
        <div class="flex shrink-0 flex-col px-5 py-2">
          @for (fact of facts(); track fact.key) {
            <div class="flex min-h-8 items-center justify-between gap-3 text-dense"><span class="text-muted-foreground">{{ fact.key }}</span><span class="truncate">{{ fact.value }}</span></div>
          }
        </div>
      }
    }

    <div panelFooter class="flex shrink-0 flex-wrap items-center gap-2 border-t border-border px-5 py-3">
      @if (store.canStart()) {
        <button hlmBtn type="button" variant="outline" size="sm" class="pr-2" [disabled]="store.running()" (click)="replan()">Neu planen<kbd class="ks-kbd">R</kbd></button>
      }
      <button hlmBtn type="button" variant="outline" size="sm" class="pr-2" (click)="correct()">Korrigieren<kbd class="ks-kbd">E</kbd></button>
      <span class="flex-1"></span>
      @if (analysisLink(); as link) {
        <a hlmBtn variant="ghost" size="sm" [routerLink]="link" [queryParams]="planning() ? { planningId: planning()!.id } : {}" title="Öffnet die Analyse mit dem Tab Planung"><ng-icon name="lucideExternalLink" class="size-3.5" />In Analyse öffnen</a>
      }
    </div>
  </app-side-panel>
}

<ng-template #addressTpl let-item>
  <span class="flex min-w-0 flex-col">
    <span class="truncate">{{ item.title ?? 'Ohne Adresse' }}</span>
    @if (item.corrections || item.replanned) {
      <span class="truncate text-xs text-muted-foreground">{{ item.corrections > 1 ? 'Korrigiert ×' + item.corrections : 'Korrigiert' }}{{ item.replanned ? ' · Nachgeplant' : '' }}</span>
    }
  </span>
</ng-template>
<ng-template #stageTpl let-item><app-stage-chip [stage]="item.stage" /></ng-template>
